import api from "./api"


// =========================================================
// HELPERS
// =========================================================

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


// =========================================================
// FORM DATA
// =========================================================

export const getEmployeeFormData =
  async () => {
    const response =
      await api.get(
        "/employees/form-data"
      )

    return response.data
  }


// =========================================================
// LISTE
// =========================================================

export const getEmployees =
  async (params = {}) => {
    const response =
      await api.get(
        "/employees",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }


// =========================================================
// DETAIL
// =========================================================

export const getEmployeeById =
  async (employeeId) => {
    const response =
      await api.get(
        `/employees/${employeeId}`
      )

    return response.data
  }


// =========================================================
// CREATE
// =========================================================

export const createEmployee =
  async (payload) => {
    const response =
      await api.post(
        "/employees",
        payload
      )

    return response.data
  }


// =========================================================
// UPDATE
// =========================================================

export const updateEmployee =
  async (
    employeeId,
    payload
  ) => {
    const response =
      await api.put(
        `/employees/${employeeId}`,
        payload
      )

    return response.data
  }


// =========================================================
// ACTIVATE
// =========================================================

export const activateEmployee =
  async (employeeId) => {
    const response =
      await api.post(
        `/employees/${employeeId}/activate`,
        {}
      )

    return response.data
  }


// =========================================================
// DEACTIVATE
// =========================================================

export const deactivateEmployee =
  async (employeeId) => {
    const response =
      await api.post(
        `/employees/${employeeId}/deactivate`,
        {}
      )

    return response.data
  }